import { Company } from './company';
import { ServiceGroup } from './service-group';
import { Price } from './price';
import { Target } from './target';

// EventType is Servive in DB
export interface EventType {
  _id?: string;
  name: string;
  duration: number;
  company: Company | string;
  // shortname: string;
  // // description: string;
  // target: Target | string;
  // service_group: ServiceGroup;
  // online_bookable?: boolean;
  // prices: any[];
  // valid_to: Date;
  // valid_from: Date;
}

export function getEmptyEventType() {
  return {
    name: "",
    duration: "",
    company: "",
    // shortname: "",
    // description: "",
    // target: "",
    // service_group:"",
    // online_bookable?:"",
    // prices: "",
    // valid_to: undefined,
    // valid_from: undefined
  }
}